import { render, staticRenderFns } from "./DatafieldValidationRule.vue?vue&type=template&id=74c0b6d5"
import script from "./DatafieldValidationRule.vue?vue&type=script&lang=js"
export * from "./DatafieldValidationRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports